export { default } from './Fab';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Fab/index.js
// module id = 676
// module chunks = 0